import { useState } from 'react';

const useCopyToClipboard = (timeout = 3000) => {
  const [copied, setCopied] = useState(false);

  const copy = (text: string) => {
    if (!navigator.clipboard) {
      console.warn('Clipboard API is not supported in this browser.');
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, timeout);
    });
  };

  return { copied, copy };
};

export default useCopyToClipboard;
